import { buildDemoStudentsForClass } from "./buildDemoStudents";

const DEMO_PERIODS = [
  {
    id: "1SEM",
    name: "1º semestre 2025",
    dateFrom: "2025-02-01",
    dateTo: "2025-06-30",
    current: false
  },
  {
    id: "2SEM",
    name: "2º semestre 2025",
    dateFrom: "2025-08-01",
    dateTo: "2025-12-15",
    current: true
  }
];

const DEMO_DISCIPLINES = [
  {
    idTurmaDisc: "88001",
    name: "Resp. Social e Ambiental",
    aulasTotais: 40,
    freqMin: 75
  },
  {
    idTurmaDisc: "88002",
    name: "Projeto Integrador 2",
    aulasTotais: 40,
    freqMin: 75
  },
  { idTurmaDisc: "88003", name: "Logística", aulasTotais: 80, freqMin: 75 },
  {
    idTurmaDisc: "88004",
    name: "Gestão Financeira",
    aulasTotais: 40,
    freqMin: 75
  }
];

const DEMO_ABSENCE_SEEDS = [
  [4, 6, 12, 4],
  [2, 4, 8, 3],
  [1, 1, 4, 2],
  [2, 3, 6, 4],
  [3, 4, 10, 6],
  [6, 8, 16, 6],
  [0, 1, 3, 0],
  [5, 7, 14, 5]
];

function maxAllowedAbsences(aulasTotais, freqMin) {
  return aulasTotais * ((100 - freqMin) / 100);
}

function absencePercent(absences, aulasTotais, freqMin) {
  const allowed = maxAllowedAbsences(aulasTotais, freqMin);
  if (allowed <= 0) return 0;
  return Math.round((absences / allowed) * 100);
}

function withDisciplineMeta(discipline) {
  return {
    ...discipline,
    maxAbsences:
      Math.round(
        maxAllowedAbsences(discipline.aulasTotais, discipline.freqMin) * 10
      ) / 10
  };
}

function parsePeriodIds(periodParam) {
  if (periodParam == null || periodParam === "") return [];
  if (Array.isArray(periodParam)) {
    return periodParam.map(item => String(item).trim()).filter(Boolean);
  }
  return String(periodParam)
    .split(",")
    .map(item => item.trim())
    .filter(Boolean);
}

function buildBoardForPeriod(classId, selectedPeriod) {
  const disciplines = DEMO_DISCIPLINES.map(withDisciplineMeta);
  const students = buildDemoStudentsForClass(classId || "DEMO-T1");
  const factor = selectedPeriod && selectedPeriod.id === "1SEM" ? 0.6 : 1;
  const absencesByRa = {};

  students.forEach((student, index) => {
    const seed = DEMO_ABSENCE_SEEDS[index % DEMO_ABSENCE_SEEDS.length];
    const counts = {};
    const items = [];

    disciplines.forEach((discipline, discIndex) => {
      const absences = Math.round(seed[discIndex] * factor);
      counts[discipline.idTurmaDisc] = {
        absences,
        percent: absencePercent(
          absences,
          discipline.aulasTotais,
          discipline.freqMin
        ),
        aulasTotais: discipline.aulasTotais,
        freqMin: discipline.freqMin,
        maxAbsences: discipline.maxAbsences
      };
      items.push({
        absences,
        aulasTotais: discipline.aulasTotais,
        freqMin: discipline.freqMin
      });
    });

    const totalAbsences = items.reduce((sum, item) => sum + item.absences, 0);
    const totalAllowed = items.reduce(
      (sum, item) => sum + maxAllowedAbsences(item.aulasTotais, item.freqMin),
      0
    );
    const summary = {
      absences: totalAbsences,
      percent:
        totalAllowed > 0 ? Math.round((totalAbsences / totalAllowed) * 100) : 0,
      aulasTotais: items.reduce((sum, item) => sum + item.aulasTotais, 0),
      maxAbsences: Math.round(totalAllowed * 10) / 10
    };

    absencesByRa[student.ra] = {
      disciplines: counts,
      period: summary,
      total: summary
    };
  });

  const gradeColumns = [];
  const gradesByRa = {};
  const concepts = ["P", "S", "N"];

  disciplines.forEach((discipline, discIndex) => {
    const etapa = selectedPeriod.id === "1SEM" ? "1" : "2";
    const provId = `${discipline.idTurmaDisc}-${etapa}-PROV`;
    const rec1Id = `${discipline.idTurmaDisc}-${etapa}-REC1`;
    const rec2Id = `${discipline.idTurmaDisc}-${etapa}-REC2`;
    const medId = `${discipline.idTurmaDisc}-${etapa}-ETAPA`;

    gradeColumns.push(
      {
        id: provId,
        header: "PROV",
        idTurmaDisc: discipline.idTurmaDisc,
        CODETAPA: etapa,
        CODPROVA: "PROV"
      },
      {
        id: rec1Id,
        header: "Rec 1",
        idTurmaDisc: discipline.idTurmaDisc,
        CODETAPA: etapa,
        CODPROVA: "REC1"
      },
      {
        id: rec2Id,
        header: "REC 2",
        idTurmaDisc: discipline.idTurmaDisc,
        CODETAPA: etapa,
        CODPROVA: "REC2"
      },
      {
        id: medId,
        header: selectedPeriod.id,
        idTurmaDisc: discipline.idTurmaDisc,
        CODETAPA: etapa,
        CODPROVA: "MED",
        kind: "etapa"
      }
    );

    students.forEach((student, index) => {
      const seed = DEMO_ABSENCE_SEEDS[index % DEMO_ABSENCE_SEEDS.length];
      if (!gradesByRa[student.ra]) gradesByRa[student.ra] = {};
      gradesByRa[student.ra][provId] =
        concepts[(index + discIndex) % concepts.length];
      gradesByRa[student.ra][rec1Id] =
        index % 4 === 0 ? null : String(6 + ((seed[discIndex] + index) % 4));
      gradesByRa[student.ra][rec2Id] =
        index % 5 === 0 ? null : String(5 + (index % 5));
      gradesByRa[student.ra][medId] = String(
        6 + ((seed[discIndex] + Number(etapa)) % 4)
      );
    });
  });

  return {
    disciplines,
    absencesByRa,
    gradeColumns,
    gradesByRa
  };
}

export function buildDemoGeneralBoard(classId, periodParam) {
  const requestedIds = parsePeriodIds(periodParam);
  const selectedPeriods = requestedIds.length
    ? DEMO_PERIODS.filter(period =>
        requestedIds.some(id => String(id) === String(period.id))
      )
    : DEMO_PERIODS.slice();

  const boardsByPeriod = {};
  selectedPeriods.forEach(period => {
    boardsByPeriod[period.id] = buildBoardForPeriod(classId, period);
  });

  return {
    periods: DEMO_PERIODS,
    selectedPeriods,
    boardsByPeriod
  };
}
